<template>
 <div>
    <div class="detailsTitle">
      <h4>用章记录</h4>
        <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="用章编号:" prop="signatureCode">
                <el-input placeholder="" v-model="searchFrom.signatureCode"></el-input>
              </el-form-item>
              <el-form-item label="业务单号:" prop="businessNo">
                <el-input  placeholder="" v-model="searchFrom.businessNo"></el-input>
              </el-form-item>
               <el-form-item label="用章场景:" prop="useScene">
                    <el-select v-model="searchFrom.useScene" placeholder="请选择">
                      <el-option v-for="val in yzcj" :label="val.name" :value="val.name" :key="val.id"></el-option>
                    </el-select>
                </el-form-item>
              <!-- <el-form-item label="用章场景:" prop="useScene">
              <el-select v-model="searchFrom.useScene" placeholder="全部">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="虚捆提货" value="1" ></el-option>
                <el-option  label="虚捆转货" value="2" ></el-option>
                <el-option  label="实捆提货" value="3" ></el-option>
                <el-option  label="实捆转货" value="4" ></el-option>
                <el-option  label="合同签订" value="5" ></el-option>
              </el-select>
              </el-form-item> -->
               <el-form-item label="用章时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div> 
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="signatureCode"  min-width="200" :formatter="emptyFn" label="用章编号"></el-table-column> 
        <el-table-column property="signatureType" label="签章关键字" min-width="120" :formatter="emptyFn">
          <!-- <template scope="scope">
            <div>
           {{[ "合同章", "财务章" ][scope.row.billType-1]}}
            </div>
          </template> -->
        </el-table-column> 
        <el-table-column prop="businessNo"  min-width="200" :formatter="emptyFn" label="业务单号"></el-table-column>
        <!-- <el-table-column property="useScene" label="用章场景" min-width="200">
          <template scope="scope">
            <div>
           {{[ "虚捆提货", "虚捆转货", "实捆提货","实捆转货", "合同签订" ][scope.row.useScene-1]}}
            </div>
          </template>
        </el-table-column>  -->
         <el-table-column property="useScene" label="用章场景" min-width="200" :formatter="emptyFn"></el-table-column> 
        <el-table-column prop="createUserName"  min-width="270" :formatter="emptyFn" label="使用人"></el-table-column>
        <!-- <el-table-column prop="createUserName"  width="150" :formatter="emptyFn" label="批准人"></el-table-column> -->
        <el-table-column prop="createTime"  min-width="200" :formatter="dateTimeFormat" label="用章时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { signatureRecordList } from '@/api/common-signature'
export default {
  data () {
    let tenantId = this.$route.query.tenantId
    return {
       yzcj: [
        { name: '虚捆提货', id: 1 },
        { name: '虚捆转货', id: 2 },
        { name: '实捆提货', id: 3 },
        { name: '实捆转货', id: 4 },
        { name: '合同签章', id: 5 },
      ],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        tenantId: tenantId,
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 查选
    searchFn () {
      if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.billNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      signatureRecordList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null,
        accountId: this.accountId,
      }
    },
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
